import role from '@/store/dictionary/role'
import seriesNumberDictionary from '@/store/dictionary/seriesNumber'
import departmentDictionary from '@/store/dictionary/department'
import serviceTypeDictionary from '@/store/dictionary/serviceType'
import licenseTypeDictionary from '@/store/dictionary/licenseType'
import clientServiceTypeDictionary from '@/store/dictionary/clientServiceType'
import softwareVersionTypeDictionary from '@/store/dictionary/softwareVersionType'
import companyDictionary from '@/store/dictionary/company'
import serviceImportanceDictionary from '@/store/dictionary/serviceImportance'
import serviceStatus from "@/store/dictionary/serviceStatus";
import serviceVisitTypeDictionary from "@/store/dictionary/serviceVisitType";
import remoteAccessTypeDictionary from "@/store/dictionary/remoteAccessType";
import positionTypeDictionary from "@/store/dictionary/positionType";
import documentTypeDictionary from "@/store/dictionary/documentType";

export default {
    state: {

    },
    mutations: {

    },
    actions: {

    },
    getters: {

    },
    modules: {
        role,
        seriesNumberDictionary,
        departmentDictionary,
        serviceTypeDictionary,
        licenseTypeDictionary,
        clientServiceTypeDictionary,
        softwareVersionTypeDictionary,
        serviceImportanceDictionary,
        serviceStatus,
        companyDictionary,
        serviceVisitTypeDictionary,
        remoteAccessTypeDictionary,
        positionTypeDictionary,
        documentTypeDictionary,
    }
}